import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useSelector, connect } from "react-redux";
import AppBar from "@material-ui/core/AppBar";
import AppBarTop from "./AppBarTop";
import AppBarBottom from "./AppBarBottom";
import { HEADER_BACKGROUND_COLOR, HEADER_TEXT_COLOR } from "../../constants";

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    flex: 1,
  },
  appBar: {
    flexDirection: "column",
    boxShadow: "none",
    backgroundColor: "white"
  }
}));

const CustomAppBar = ({userName}) => {
  const classes = useStyles();
  const drawerWidth = useSelector(state => state.common.drawerWidth);

  return (
    <div className={classes.root}>
      <AppBar color="default" position="sticky" className={classes.appBar}>
        <AppBarTop drawerWidth={drawerWidth} userName={userName}
                   backgroundColor={HEADER_BACKGROUND_COLOR}
                   textColor={HEADER_TEXT_COLOR} />
        <AppBarBottom drawerWidth={drawerWidth} />
      </AppBar>
    </div>
  );
};

export default connect(
  ({ global: { userData } }) => ({
    userName: userData.name,
  }),
)(CustomAppBar);
